export const spaceTypesTranslations = {
  DESK: 'spaces:createSpace.desk',
  ROOM: 'spaces:createSpace.room',
} as const;
